var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.visible
    ? _c("div", [
        _c("div", { staticClass: "gc_mask", on: { click: _vm.goClose } }),
        _c("div", { staticClass: "modal-top", on: { click: _vm.goClose } }, [
          _c("div", {
            staticClass: "gl_share",
            style: {
              backgroundImage: "url(" + _vm.$t("topHeader.shareImg") + ")"
            }
          })
        ])
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }